import Vue from "vue";
import moment from "moment";
import EventBus from "@/lib/utilities/eventBus.js";
import {
  NavMenuCategory,
  EventBusEvents,
  UserCustomNotificationType
} from "@/lib/utilities/enums";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    UserSearchModalInfo: {
      showModal: false,
      value: null,
      actionType: "",
      existingItems: [],
      key: null,
      pageId: null
    },
    ContactSearchSavedSearches: [],
    DashboardSavedSearch: null,
    LeadsDashboardSavedSearches: []
  };
}

function createPayload(key, value) {
  let payload = {
    key: key,
    value: HelperFunctions.parseToJSONString(value)
  };
  return payload;
}

const state = initialState();

const actions = {
  getUserSettings: function(context, key) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/usersettings/key/" + key)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.Data &&
            response.data.Data.length > 0
          ) {
            let data = response.data.Data;
            data.sort((result1, result2) => {
              return result1.UpdateDT > result2.UpdateDT ? 1 : -1;
            });
            resolve(data[0]);
          } else resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveUserSettings: function(context, data) {
    let payload = createPayload(data.key, data.request);
    return new Promise((resolve, reject) => {
      Vue.http
        .put("/usersettings/key/" + payload.key, payload)
        .then(response => {
          if (response) resolve(response);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateUserSearchModal: function(context, data) {
    context.commit("updateUserSearchModal", data);
  },
  updateContactSearchSavedSearches: function(context, data) {
    context.commit("updateContactSearchSavedSearches", data);
  },
  updateDashboardSavedSearch: function(context, data) {
    context.commit("updateDashboardSavedSearch", data);
  },
  updateLeadsDashboardSavedSearches: function(context, data) {
    context.commit("updateLeadsDashboardSavedSearches", data);
  },
  updateCallTrackingDashboardSavedSearches: function(context, data) {
    context.commit("updateCallTrackingDashboardSavedSearches", data);
  },
  formatAndUpdateDashboardLayout: function(context, data) {
    let payload = HelperFunctions.parseStringToJSON(data);
    return payload ? payload : [];
  },
  saveDashboardSettings: function(context, data) {
    return new Promise((resolve, reject) => {
      context
        .dispatch("saveUserSettings", data)
        .then(response => {
          if (response && response.data) {
            let data = response.data.Data;
            context.commit(
              "updateDashboardSavedSearch",
              data && data.Value ? data.Value : null
            );
          }
          resolve(response);
        })
        .catch(ex => {
          reject(ex);
        });
    });
  },
  savePageFilters: function(context, request) {
    let data = request.data;
    let key = request.key;
    let existingItems = request.existingItems;
    let pageId = request.pageId;

    let isNewItem = !(data.Id && data.Id > 0);
    if (isNewItem) data.Id = moment().valueOf();

    context.commit("addNewPageFilter", {
      data: data,
      isNewItem: isNewItem,
      existingItems: existingItems,
      pageId: pageId
    });
    return new Promise((resolve, reject) => {
      context
        .dispatch("saveUserSettings", { key: key, request: existingItems })
        .then(savedRespnse => {
          resolve(data.Id);
        })
        .catch(ex => {
          reject(ex);
        });
    });
  },
  deleteSavedSearch: function(context, request) {
    return new Promise((resolve, reject) => {
      context
        .dispatch("saveUserSettings", {
          key: request.key,
          request: request.existingItems
        })
        .then(data => {
          if (request.pageId == NavMenuCategory.ContactSearch)
            context.commit("updateSavedContactResults", request.existingItems);
          else if (request.pageId == NavMenuCategory.LeadsDashboard)
            context.commit(
              "updateSavedLeadsDashboardResults",
              request.existingItems
            );
          resolve(request.Id);
        })
        .catch(ex => {
          reject(ex);
        });
    });
  },
  sendCustomNotificationToUser: async function(context, requestPackage) {
    return await Vue.http
      .post(`/users/${requestPackage.UserId}/notify`, requestPackage)
      .catch(err => err.response);
  },
  handleUserCustomNotification: async function(context, notification) {
    // console.log("User Custom Notification: ", notification);
    if (!notification || !notification.action) return;

    switch (notification.action) {
      case UserCustomNotificationType.CUSTOMER_PROFILE_UPDATE:
        // If the current customer profile is updated, refresh
        if (
          context.getters.CurrentContact &&
          notification.data &&
          notification.data.contactId == context.getters.CurrentContact.id
        )
          EventBus.$emit(EventBusEvents.ReloadCustomerDashboard);
        break;
      case UserCustomNotificationType.USER_PROFILE_LOGOUT:
        EventBus.$emit(EventBusEvents.UserProfileLogout, notification.data);
        break;
      case UserCustomNotificationType.GLOBAL_FRAME_HEADER_INFO_UPDATE:
        context.dispatch("updateMenuPreference", notification.data);
        break;
    }
  }
};

const mutations = {
  updateUserSearchModal: function(state, data) {
    state.UserSearchModalInfo = data;
  },
  updateContactSearchSavedSearches: function(state, data) {
    let payload = HelperFunctions.parseStringToJSON(data);
    state.ContactSearchSavedSearches = payload ? payload : [];
  },
  updateDashboardSavedSearch: function(state, data) {
    let payload = HelperFunctions.parseStringToJSON(data);
    //we do not want array in this case. API returns empty array if it has no data
    if (Array.isArray(payload)) payload = null;
    state.DashboardSavedSearch = payload ? payload : null;
  },
  updateLeadsDashboardSavedSearches: function(state, data) {
    let payload = HelperFunctions.parseStringToJSON(data);
    state.LeadsDashboardSavedSearches = payload ? payload : [];
  },
  updateCallTrackingDashboardSavedSearches: function(state, data) {
    let payload = HelperFunctions.parseStringToJSON(data);
    state.LeadsDashboardSavedSearches = payload ? payload : [];
  },
  addNewPageFilter: function(state, data) {
    let item = data.data;
    let existingItems = data.existingItems;

    if (data.isNewItem) {
      existingItems.push({
        Id: item.Id,
        Name: item.name,
        Value: HelperFunctions.parseToJSONString(item.value)
      });
    } else {
      let index = existingItems.findIndex(x => x.Id == item.Id);
      existingItems.splice(index, 1, item);
    }
    if (data.pageId == NavMenuCategory.ContactSearch)
      state.ContactSearchSavedSearches = existingItems;
    else if (data.pageId == NavMenuCategory.LeadsDashboard)
      state.LeadsDashboardSavedSearches = existingItems;
  },
  updateSavedContactResults: function(state, data) {
    state.ContactSearchSavedSearches = data;
  },
  updateSavedLeadsDashboardResults: function(state, data) {
    state.LeadsDashboardSavedSearches = data;
  }
};

const getters = {
  ContactSearchSavedSearches: function() {
    return state.ContactSearchSavedSearches;
  },
  DashboardSavedSearch: function() {
    return state.DashboardSavedSearch;
  },
  LeadsDashboardSavedSearches: function() {
    return state.LeadsDashboardSavedSearches;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/UserSettings.js